export { default } from './RatingComment';